var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"datenschutz"}},[_c('div',{staticClass:"container-fluid"},[_c('article',{staticClass:"rechtliches-article"},[_c('vue-simple-markdown',{attrs:{"source":_vm.privacy.privacy}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }